import { TariffFilter } from '../api/tariffApi';
import { DropdownItem } from '../components/ui/input/DropdownInput';
import { SimManagementError } from '../models/Errors';
import {
  ENSURE_PORT_NETWORKS,
  LOAD_PORT_NETWORKS,
  LOAD_PORT_NETWORKS_FAILURE,
  LOAD_PORT_NETWORKS_PENDING,
  LOAD_PORT_NETWORKS_SUCCESS,
} from './actionTypes';
import { Action, ActionMeta, PromiseAction, RejectFunc, ResolveFunc } from './commonActions';

export function ensurePortNetworks(networkId: number): Action<number> {
  return {
    type: ENSURE_PORT_NETWORKS,
    payload: networkId,
  };
}

export function loadPortNetworks(
  filter: TariffFilter,
  resolve?: ResolveFunc<DropdownItem[]>,
  reject?: RejectFunc,
): PromiseAction<TariffFilter, DropdownItem[]> {
  return {
    type: LOAD_PORT_NETWORKS,
    payload: filter,
    resolve,
    reject,
  };
}

export function loadPortNetworksPending(networkId: number): Action<number> {
  return {
    type: LOAD_PORT_NETWORKS_PENDING,
    payload: networkId,
  };
}

export function loadPortNetworksSuccess(networkId: number, items: DropdownItem[]): ActionMeta<number, DropdownItem[]> {
  return {
    type: LOAD_PORT_NETWORKS_SUCCESS,
    payload: networkId,
    meta: items,
  };
}

export function loadPortNetworksFailure(
  networkId: number,
  error: SimManagementError,
): ActionMeta<number, SimManagementError> {
  return {
    type: LOAD_PORT_NETWORKS_FAILURE,
    payload: networkId,
    meta: error,
  };
}
